import { render, staticRenderFns } from "./MRefreshQueryButton.vue?vue&type=template&id=572e0d6a&lang=pug&"
import script from "./MRefreshQueryButton.vue?vue&type=script&lang=js&"
export * from "./MRefreshQueryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports